import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router'

import { Observable, of } from 'rxjs'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import { select, Store } from '@ngrx/store'
import { selectUsersLoaded } from './user-signature.selectors'
import { GetCurrentUser } from './user-signature.actions'

@Injectable()
export class UserSignatureGuard {
  constructor(private store: Store<any>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectUsersLoaded),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(GetCurrentUser())
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate()
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
